import Button from '@/components/UI/Button';
import Image from '@/components/UI/Image';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';
import { useGlobal } from '@/utils/useGlobal';
import styled from './index.module.scss';
const StoryNewWorld = () => {
    const { useState, isMobile, useLang, Link } = useGlobal();
    const { t } = useLang('brandstory');
    const list = [
        {
            imgurl: 'https://websiteoss.ecoflow.com/upload/image/1733740072966/d3p.png',
            name: t('newworld.recommend0'),
            link: 'https://jp.ecoflow.com/products/delta-3-plus-portable-power-station?variant=44597213003937',
        },
        {
            imgurl: 'https://websiteoss.ecoflow.com/upload/image/1733740072967/dp3.png',
            name: t('newworld.recommend1'),
            link: 'https://jp.ecoflow.com/products/delta-pro-3?variant=44261300175009',
        },
        {
            imgurl: 'https://websiteoss.ecoflow.com/upload/image/1733740072965/d2m.png',
            name: t('newworld.recommend2'),
            link: 'https://jp.ecoflow.com/products/delta-2-max-portable-power-station?variant=43020979863713',
        },
    ];

    if (isMobile) {
        list.pop();
    }

    return (
        <div className={`${isMobile ? styled.story_mobile_ewworld : styled.story_newworld} content`}>
            <div className="header">
                <h5 className="screen-title">{t('menu.newworld')}</h5>
                <h5 className="screen-desc">{t('newworld.title')}</h5>
            </div>
            <div className="link">
                <Link href="https://jp.ecoflow.com/" target="_blank">
                    <Button type="link" className="link-btn font-family-medium" aria-label={t('newworld.morebtn')} style={{ color: '#0066CC' }}>
                        {t('newworld.morebtn')}
                        <span className="more">
                            <EFArrowLeft />
                        </span>
                    </Button>
                </Link>
            </div>
            <div className="commoditylist">
                {list.map((item) => (
                    <div className="commodity" key={item.name}>
                        <div className="img">
                            <Image src={item.imgurl} layout="fill" className="fullImgs" alt={item.name} aria-label={item.name} />
                        </div>
                        <p className="name">{item.name}</p>
                        <div className="link">
                            <Link href={item.link} target="_blank">
                                <Button type="link" className="link-btn font-family-medium" aria-label={t('newworld.morebtn')} style={{ color: '#0066CC' }}>
                                    {t('newworld.morebtn')}
                                    <span className="more">
                                        <EFArrowLeft />
                                    </span>
                                </Button>
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StoryNewWorld;
